module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.idioma === 'DE') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Bereiche")]) : (_vm.idioma === 'EN') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Areas")]) : (_vm.idioma === 'ES') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Áreas")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Áreas")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Hauptsächlich")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Home")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/manutencao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Wartung")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Maintenance")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Mantenimiento")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Manutenção")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Grafik")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Graphics")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-gerais"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Allgemeines")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" General")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" General")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Gerais")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-material"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-acumulados"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Kumuliert pro Tag")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Accumulated per day")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Acumulado por día")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Acumulados por dia")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Nutzer")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("User")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuario")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuário")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Ausgehen")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Exit")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Salir")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Sair")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-457cc623"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 677
// module chunks = 1